import { ComputedRef, defineComponent } from 'vue'
import { useStore } from '@/store'
import { arraySlice, hanldeNewsDetails } from '@/utils/util'
import ImagePreview from '@/components/ImagePreview'
import NewsDetails from '@/components/NewsDetails'

import styles from './style.module.less'

export default defineComponent({
  name: 'MostReadRight',
  props: {
    data: Array as PropType<any[]>
  },
  setup(props) {
    const store = useStore()

    const dataSource: ComputedRef<(NewsItem & { bgColor?: string })[]>  = computed(() => {
      return arraySlice(props.data?.map(item => hanldeNewsDetails(item)) || [], 5).map((item, index) => {
        switch (index) {
          case 0:
            item.bgColor = 'linear-gradient(270deg,#fff,#f4dedf)'
            break
          case 1:
            item.bgColor = 'linear-gradient(270deg,#fff,#fee8d9)'
            break
          case 2:
            item.bgColor = 'linear-gradient(270deg,#fff,#fff6e2)'
            break
          default:
            item.bgColor = 'linear-gradient(270deg,#fff,#f2f2f2)'
            break
        }
        return item
      })
    })

    onMounted(() => {
      // console.log(homeData.value)
      // console.log(dataSource.value)
    })

    return () => (
      <>
        {
          dataSource.value?.length > 0 && (
            <>
              <div class={'text-20px leading-26px text-font-bold text-hex-000 mb-16px'}>Most Read</div>
              {
                dataSource.value.map((item, index) => (
                  <div class={styles.mostReadListItem} onClick={() => store.global.publicOpenDetails(item, true)}>
                    <div
                      style={{ background: item.bgColor }}
                      class={styles.recommondCurrent}
                    >
                      {`0${index + 1}`}
                    </div>
                    {
                      (index === 0 && !item.noImageStyle) && (
                        <ImagePreview
                          width={320}
                          height={240}
                          url={item.imageShow}
                          coverStyle={item.coverStyle as any}
                          alt={item.newsTitle}
                          record={item.noImageStyle ? undefined : item}
                        />
                      )
                    }
                    <div class={styles.title}>{item.newsTitle}</div>
                    {
                      item.noImageStyle || index === 0 ? (
                        <>
                          {item.noImageStyle && (
                            <div class={[ styles.description, 'mb-12px' ]}>
                              {item.newsSummary || item.newsTitle}
                            </div>
                          )}
                          <NewsDetails
                            time={item.publishTime}
                            channelName={item.mainChannel?.channelName}
                            record={item.noImageStyle ? item : undefined}
                          />
                        </>
                      ) : index !== 0 && (
                        <div class={'flex gap-12px'}>
                          <div class={'flex-main-120'}>
                            <ImagePreview
                              width={120}
                              height={91}
                              coverStyle={item.coverStyle as any}
                              url={item.imageShow}
                              alt={item.newsTitle}
                              record={item.noImageStyle ? undefined : item}
                            />
                          </div>
                          <div class={'flex justify-between flex-col flex-main'}>
                            <div class={styles.description}>
                              {item.newsSummary || item.newsTitle}
                            </div>
                            <NewsDetails
                              hiddenFullTime
                              time={item.publishTime}
                              channelName={item.mainChannel?.channelName}
                              record={item.noImageStyle ? item : undefined}
                            />
                          </div>
                        </div>
                      )
                    }
                  </div>
                ))
              }
            </>
          )
        }
      </>
    )
  }
})
